@for (property of properties; track property) {
  <ul>
    <li [ngClass]="{'no-children' : property.isPrimitive}">
      @if (!property.isPrimitive) {
        <a (click)="toggleChildrenVisibility(property)" [ngClass]="{'rotate' : !property.isCollapsed}" class="dropdown-icon">
          <span class="sap-icon">&#xe066;</span>
        </a>
      }
      {{property.name}}
      @if (property.propertiesAndFunctions.length > 0 && !property.isCollapsed) {
        <cpq-scripting-property [properties]="property.propertiesAndFunctions"></cpq-scripting-property>
      }
    </li>
  </ul>
}